export function useCheckScreenSize() {
  const isDesktop = window.innerWidth > 800;
  const isWideScreen = window.innerWidth > 1600;

  return { isDesktop: isDesktop, isWideScreen: isWideScreen };
}
